import { Avatar, Tooltip } from 'antd';
import defaultAvatarImg from '@/assets/images/web/default_avatar.webp';
import s from './style.module.scss';
import { inject, observer } from 'mobx-react';
import withRouter from '@/components/withRouter';
import roleImg from '@/assets/images/simulation/role_icon.webp';
import backImg from '@/assets/images/simulation/back_icon.webp';
import reStartImg from '@/assets/images/simulation/restart.webp';
import { Display } from '@/components/Display/Display';
import RoleIntroduceModal from '../Modal/RoleIntroduceModal';
import BackModal from '../Modal/BackModal';
import { getSearchStr } from '@/utils/Page';

import { handleRestart } from '@/api/grt/simulation';
import { LeftOutlined } from '@ant-design/icons';
const searchStr = getSearchStr();
const SimulationHeader = (props) => {
    let { navigate, params } = props;
    let { agentId, caseId, sceneId } = params;
    let {
        store: { simulation, grtAi }
    } = props;
    let { headerIcon, closeGuideModal, caseInfo } = simulation;
    //角色弹窗
    const showGuideModal = () => {
        //引导弹窗打开时点击的--保存到浏览器
        if (simulation.guideModalName) {
            simulation.handleRoleStorage(true);
        }
        simulation.setGuideModalShow({
            role: true
        });
    };
    //背景弹窗
    const showBackModal = () => {
        if (simulation.guideModalName) {
            simulation.handleBackStorage(true);
        }
        simulation.setGuideModalShow({
            back: true
        });
    };
    //重新开始弹窗
    const showRestartModal = () => {
        simulation.setGuideModalShow({
            role: false,
            back: false,
            restart: true
        });
    };

    const reStart = async () => {
        let res = await handleRestart(caseId);
        if (res && res.success) {
            //请求接口
            //重置数据请求最新数据
            //跳到背景页
            simulation.getContent();
            closeGuideModal();
            navigate(`/web/o/${agentId}/simulation/${caseId}/${sceneId}/background${searchStr}`);
        }
    };
    return (
        <>
            <BackModal show={simulation.guideModalShow.back} onClose={closeGuideModal}></BackModal>
            <RoleIntroduceModal show={simulation.guideModalShow.role} onClose={closeGuideModal}></RoleIntroduceModal>

            <div className={s['header-box']} style={{ position: simulation.guideModalName ? 'static' : 'sticky' }}>
                <div className={s['left']}>
                    <div className={s['header-title']}>{caseInfo?.scene_name}</div>
                    <div className={s['ai-tip']}>内容由AI生成</div>
                </div>
                <div className={s['right']}>
                    <Display show={simulation.guideModalName}>
                        <>
                            <div className={s['mask']}></div>
                            <div data-type={simulation.guideModalName} className={`${s['pulse-point']} pulse-point`}></div>
                            <div data-type={simulation.guideModalName} className={s['line-box']}>
                                <div className={s['line-arrow']}>
                                    <LeftOutlined />
                                </div>
                                <div className={s['line-text']}>
                                    {simulation.guideModalName === 'back' ? '点击可查看事件背景' : '点击可查看角色规则介绍'}
                                </div>
                            </div>
                        </>
                    </Display>
                    <Display show={headerIcon.reStart}>
                        <div onClick={showRestartModal} className={s['header-icon']}>
                            <Tooltip title="重新开始">
                                <img src={reStartImg} alt="" />
                            </Tooltip>
                        </div>
                    </Display>
                    <Display show={headerIcon.role}>
                        <div onClick={showGuideModal} data-guide={simulation.guideModalName === 'role'} className={s['header-icon']}>
                            <Tooltip title="角色回顾">
                                <img src={roleImg} alt="" />
                            </Tooltip>
                        </div>
                    </Display>
                    <Display show={headerIcon.back}>
                        <div onClick={showBackModal} data-guide={simulation.guideModalName === 'back'} className={`${s['header-icon']}`}>
                            <Tooltip title="背景回顾">
                                <img src={backImg} alt="" />
                            </Tooltip>
                        </div>
                    </Display>

                    <Avatar className={s['avatar']} src={grtAi?.userInfo?.avatar || defaultAvatarImg}></Avatar>
                </div>
            </div>
        </>
    );
};

export default withRouter(inject('store')(observer(SimulationHeader)));
